const lang = {
    'title': 'Newsroom',
    'request': 'For all press inquiries and requests, please drop a line to <a href="mailto:press.tw@ridegoshare.com" target="_blank" rel="noopener noreferrer">press.tw@ridegoshare.com</a> and we will be in touch soon.',
};

export default lang;
